import {
  Close_default
} from "./chunk-ONOYXPIT.mjs";
import {
  cn
} from "./chunk-DYSUVPH5.mjs";

// src/components/toaster/toaster.tsx
import { Transition } from "@headlessui/react";
import React from "react";
import { toast as defaultToast, Toaster } from "react-hot-toast";
var customToast = (children, { duration = 3e3, className = "bg-toast" }) => defaultToast.custom(
  (t) => /* @__PURE__ */ React.createElement(
    Transition,
    {
      appear: true,
      show: t.visible,
      enter: "transition transform duration-300 ease-out",
      enterFrom: "opacity-0",
      enterTo: "opacity-100",
      leave: "transition transform duration-150 ease-in",
      leaveFrom: "opacity-100",
      leaveTo: "opacity-0"
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cn(
          "my-1 flex rounded py-4 pl-4 text-toast-text my-body-sm",
          className
        )
      },
      children,
      /* @__PURE__ */ React.createElement(
        "button",
        {
          onClick: () => defaultToast.dismiss(t.id),
          className: "justify-self-end px-4"
        },
        /* @__PURE__ */ React.createElement(Close_default, { width: 18 })
      )
    )
  ),
  { duration }
);
var toaster = {
  positive: (children, duration) => customToast(children, {
    className: "bg-semantic-success-surface-subtle",
    duration
  }),
  negative: (children, duration) => customToast(children, {
    className: "bg-semantic-critical-surface-subtle",
    duration
  }),
  warning: (children, duration) => customToast(children, {
    className: "bg-semantic-warning-surface-subtle",
    duration
  })
};

export {
  Toaster,
  toaster
};
